// extracted by mini-css-extract-plugin
export default {"space":"styles_space__Qq3Xt","dropdown":"styles_dropdown__e4SjY","button":"styles_button__bdy4h","ant-btn-disabled":"styles_ant-btn-disabled__jni23"};